export default __webpack_public_path__ + "static/media/juego_paso39.b32fb097.png";